import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const name = 'ProjectNames';

export const useProjectNamesStyles = makeStyles({ name })(theme => ({
  link: {
    fontSize: 14,
    fontWeight: 400,
    color: theme.palette.text.secondary,
    borderBottom: `1px solid ${alpha(theme.palette.link.main, 0.5)}`,
    textDecoration: 'none',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    '&:hover': {
      color: theme.palette.text.secondary,
      borderBottom: `1px solid ${theme.palette.link.main}`,
      textDecoration: 'none',
    },
  },
  name: {
    whiteSpace: 'nowrap',
  },
}));
